export default {
  title: 'Il n’est plus possible \n' + 'd’ajouter des produits',
  description:
    'Nous avons déjà commencé à préparer votre commande, il n’est plus possible de la modifier.',
  ok: "J'ai compris",
};
